// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "lazy-chunk.logger" + "." + "9e1e608c" + ".chunk.js";
};